module.exports = __webpack_public_path__ + "img/17.321d53da.jpg";